/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GetSharedItemBySlugQueryVariables = {|
  slug: string,
  securityPass?: ?string,
|};
export type GetSharedItemBySlugQueryResponse = {|
  +getSharedStudioItemBySlug: ?{|
    +content?: $ReadOnlyArray<?({|
      +__typename: "Coverpage",
      +_id: string,
      +name: string,
      +mainHeading: string,
      +details: string,
      +coverpageTemplateId: number,
      +thumbnail: ?string,
      +showroomIds: ?$ReadOnlyArray<string>,
      +showroomLink: string,
      +creator: string,
      +coverpageAccountId: string,
      +templateStyle: ?{|
        +cardPosition: ?string,
        +BackgroundBlur: ?string,
      |},
      +updatedAt: ?any,
    |} | {|
      +__typename: "Microsite",
      +_id: string,
      +name: string,
      +showroomsIds: ?$ReadOnlyArray<string>,
      +backgroundImage: ?string,
      +coverpageId: ?string,
      +micrositeTemplateId: ?number,
      +portalId: string,
      +creator: string,
      +micrositeAccountId: string,
    |} | {|
      +__typename: "Magazine",
      +_id: string,
      +id: string,
      +name: string,
      +backgroundColor: ?string,
      +backgroundImage: ?string,
      +mainTemplateId: string,
      +subTemplateId: number,
      +portalId: string,
      +rows: ?$ReadOnlyArray<?{|
        +content: ?$ReadOnlyArray<?{|
          +heading: ?string,
          +subHeading: ?string,
          +description: ?string,
          +headerImage: ?string,
          +fileUrl: ?string,
          +videoThumbnail: ?string,
          +cardThumbnail: ?string,
          +headerOverlayContent: ?string,
          +linkTo: ?string,
          +buttonText: ?string,
          +graphData: ?{|
            +attr1: ?string,
            +attr2: ?string,
            +attr3: ?string,
            +data: ?$ReadOnlyArray<?{|
              +name: ?string,
              +val1: ?number,
              +val2: ?number,
              +val3: ?number,
            |}>,
          |},
        |}>,
        +isShown: ?boolean,
      |}>,
      +thumbnail: ?string,
      +creator: string,
      +magazineAccountId: ?string,
    |} | {|
      +__typename: "Showroom",
      +_id: string,
      +id: string,
      +name: string,
      +backgroundImage: ?string,
      +mainHeading: string,
      +headerImage: ?string,
      +subHeading: string,
      +showroomTemplateId: number,
      +tags: ?$ReadOnlyArray<string>,
      +link: ?string,
      +creator: string,
      +coverpagesIds: ?$ReadOnlyArray<string>,
      +showroomAccountId: ?string,
      +content: ?$ReadOnlyArray<?{|
        +name: string,
        +content: ?$ReadOnlyArray<?{|
          +image: string,
          +mainHeading: string,
          +presentationId: string,
          +subHeading: string,
          +imageUrl: string,
          +presentation: ?{|
            +coverUrl: ?string,
            +portalId: string,
            +name: string,
            +menuId: string,
            +folderId: string,
          |},
          +files: ?$ReadOnlyArray<?{|
            +_id: string,
            +name: string,
            +relatedPresentationIds: $ReadOnlyArray<string>,
            +fileUrl: string,
            +fileType: string,
            +coverUrl: ?string,
            +thumbnailUrl: ?string,
            +positions: $ReadOnlyArray<?{|
              +presentationId: string,
              +position: number,
            |}>,
            +visibility: ?boolean,
            +creator: string,
          |}>,
        |}>,
      |}>,
    |} | {|
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      +__typename: "%other"
    |})>,
    +__typename: "Response",
    +message?: string,
    +status?: number,
    +success?: boolean,
  |}
|};
export type GetSharedItemBySlugQuery = {|
  variables: GetSharedItemBySlugQueryVariables,
  response: GetSharedItemBySlugQueryResponse,
|};
*/


/*
query GetSharedItemBySlugQuery(
  $slug: String!
  $securityPass: String
) {
  getSharedStudioItemBySlug(slug: $slug, securityPass: $securityPass) {
    __typename
    ... on SharedStudioItemResponse {
      content {
        __typename
        ... on Coverpage {
          __typename
          _id
          name
          mainHeading
          details
          coverpageTemplateId: templateId
          thumbnail
          showroomIds
          showroomLink
          creator
          coverpageAccountId: accountId
          templateStyle {
            cardPosition
            BackgroundBlur
          }
          updatedAt
        }
        ... on Microsite {
          __typename
          _id
          name
          showroomsIds
          backgroundImage
          coverpageId
          micrositeTemplateId: templateId
          portalId
          creator
          micrositeAccountId: accountId
        }
        ... on Magazine {
          __typename
          _id
          id
          name
          backgroundColor
          backgroundImage
          mainTemplateId
          subTemplateId
          portalId
          rows {
            content {
              heading
              subHeading
              description
              headerImage
              fileUrl
              videoThumbnail
              cardThumbnail
              headerOverlayContent
              linkTo
              buttonText
              graphData {
                attr1
                attr2
                attr3
                data {
                  name
                  val1
                  val2
                  val3
                }
              }
            }
            isShown
          }
          thumbnail
          creator
          magazineAccountId: accountId
        }
        ... on Showroom {
          __typename
          _id
          id
          name
          backgroundImage
          mainHeading
          headerImage
          subHeading
          showroomTemplateId: templateId
          tags
          link
          creator
          coverpagesIds
          showroomAccountId: accountId
          content {
            name
            content {
              image
              mainHeading
              presentationId
              subHeading
              imageUrl
              presentation {
                coverUrl
                portalId
                name
                menuId
                folderId
              }
              files {
                _id
                name
                relatedPresentationIds
                fileUrl
                fileType
                coverUrl
                thumbnailUrl
                positions {
                  presentationId
                  position
                }
                visibility
                creator
              }
            }
          }
        }
      }
    }
    ... on Response {
      __typename
      message
      status
      success
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "securityPass"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v2 = [
  {
    "kind": "Variable",
    "name": "securityPass",
    "variableName": "securityPass"
  },
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mainHeading",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "details",
  "storageKey": null
},
v8 = {
  "alias": "coverpageTemplateId",
  "args": null,
  "kind": "ScalarField",
  "name": "templateId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showroomIds",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showroomLink",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creator",
  "storageKey": null
},
v13 = {
  "alias": "coverpageAccountId",
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "TemplateStyle",
  "kind": "LinkedField",
  "name": "templateStyle",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardPosition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "BackgroundBlur",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showroomsIds",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backgroundImage",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverpageId",
  "storageKey": null
},
v19 = {
  "alias": "micrositeTemplateId",
  "args": null,
  "kind": "ScalarField",
  "name": "templateId",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "portalId",
  "storageKey": null
},
v21 = {
  "alias": "micrositeAccountId",
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "backgroundColor",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mainTemplateId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subTemplateId",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subHeading",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "headerImage",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileUrl",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Row",
  "kind": "LinkedField",
  "name": "rows",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Card",
      "kind": "LinkedField",
      "name": "content",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "heading",
          "storageKey": null
        },
        (v26/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        (v27/*: any*/),
        (v28/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "videoThumbnail",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cardThumbnail",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headerOverlayContent",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linkTo",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "buttonText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Graph",
          "kind": "LinkedField",
          "name": "graphData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "attr1",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "attr2",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "attr3",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "GraphData",
              "kind": "LinkedField",
              "name": "data",
              "plural": true,
              "selections": [
                (v5/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "val1",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "val2",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "val3",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isShown",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": "magazineAccountId",
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v31 = {
  "alias": "showroomTemplateId",
  "args": null,
  "kind": "ScalarField",
  "name": "templateId",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverpagesIds",
  "storageKey": null
},
v35 = {
  "alias": "showroomAccountId",
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "presentationId",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverUrl",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "content",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NestedContent",
      "kind": "LinkedField",
      "name": "content",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "image",
          "storageKey": null
        },
        (v6/*: any*/),
        (v36/*: any*/),
        (v26/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Presentation",
          "kind": "LinkedField",
          "name": "presentation",
          "plural": false,
          "selections": [
            (v37/*: any*/),
            (v20/*: any*/),
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "menuId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "folderId",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "File",
          "kind": "LinkedField",
          "name": "files",
          "plural": true,
          "selections": [
            (v4/*: any*/),
            (v5/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "relatedPresentationIds",
              "storageKey": null
            },
            (v28/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "fileType",
              "storageKey": null
            },
            (v37/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "thumbnailUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Position",
              "kind": "LinkedField",
              "name": "positions",
              "plural": true,
              "selections": [
                (v36/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "position",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "visibility",
              "storageKey": null
            },
            (v12/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "GetSharedItemBySlugQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "getSharedStudioItemBySlug",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": true,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/)
                    ],
                    "type": "Coverpage",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v12/*: any*/),
                      (v21/*: any*/)
                    ],
                    "type": "Microsite",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v22/*: any*/),
                      (v5/*: any*/),
                      (v23/*: any*/),
                      (v17/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v20/*: any*/),
                      (v29/*: any*/),
                      (v9/*: any*/),
                      (v12/*: any*/),
                      (v30/*: any*/)
                    ],
                    "type": "Magazine",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v22/*: any*/),
                      (v5/*: any*/),
                      (v17/*: any*/),
                      (v6/*: any*/),
                      (v27/*: any*/),
                      (v26/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v12/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v38/*: any*/)
                    ],
                    "type": "Showroom",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "SharedStudioItemResponse",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/)
            ],
            "type": "Response",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "GetSharedItemBySlugQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "getSharedStudioItemBySlug",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/)
                    ],
                    "type": "Coverpage",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v12/*: any*/),
                      (v21/*: any*/)
                    ],
                    "type": "Microsite",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      (v22/*: any*/),
                      (v5/*: any*/),
                      (v23/*: any*/),
                      (v17/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v20/*: any*/),
                      (v29/*: any*/),
                      (v9/*: any*/),
                      (v12/*: any*/),
                      (v30/*: any*/)
                    ],
                    "type": "Magazine",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      (v22/*: any*/),
                      (v5/*: any*/),
                      (v17/*: any*/),
                      (v6/*: any*/),
                      (v27/*: any*/),
                      (v26/*: any*/),
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v12/*: any*/),
                      (v34/*: any*/),
                      (v35/*: any*/),
                      (v38/*: any*/)
                    ],
                    "type": "Showroom",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "SharedStudioItemResponse",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v39/*: any*/),
              (v40/*: any*/),
              (v41/*: any*/)
            ],
            "type": "Response",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "509f1be30dedeba526839f8b730d4ca3",
    "id": null,
    "metadata": {},
    "name": "GetSharedItemBySlugQuery",
    "operationKind": "query",
    "text": "query GetSharedItemBySlugQuery(\n  $slug: String!\n  $securityPass: String\n) {\n  getSharedStudioItemBySlug(slug: $slug, securityPass: $securityPass) {\n    __typename\n    ... on SharedStudioItemResponse {\n      content {\n        __typename\n        ... on Coverpage {\n          __typename\n          _id\n          name\n          mainHeading\n          details\n          coverpageTemplateId: templateId\n          thumbnail\n          showroomIds\n          showroomLink\n          creator\n          coverpageAccountId: accountId\n          templateStyle {\n            cardPosition\n            BackgroundBlur\n          }\n          updatedAt\n        }\n        ... on Microsite {\n          __typename\n          _id\n          name\n          showroomsIds\n          backgroundImage\n          coverpageId\n          micrositeTemplateId: templateId\n          portalId\n          creator\n          micrositeAccountId: accountId\n        }\n        ... on Magazine {\n          __typename\n          _id\n          id\n          name\n          backgroundColor\n          backgroundImage\n          mainTemplateId\n          subTemplateId\n          portalId\n          rows {\n            content {\n              heading\n              subHeading\n              description\n              headerImage\n              fileUrl\n              videoThumbnail\n              cardThumbnail\n              headerOverlayContent\n              linkTo\n              buttonText\n              graphData {\n                attr1\n                attr2\n                attr3\n                data {\n                  name\n                  val1\n                  val2\n                  val3\n                }\n              }\n            }\n            isShown\n          }\n          thumbnail\n          creator\n          magazineAccountId: accountId\n        }\n        ... on Showroom {\n          __typename\n          _id\n          id\n          name\n          backgroundImage\n          mainHeading\n          headerImage\n          subHeading\n          showroomTemplateId: templateId\n          tags\n          link\n          creator\n          coverpagesIds\n          showroomAccountId: accountId\n          content {\n            name\n            content {\n              image\n              mainHeading\n              presentationId\n              subHeading\n              imageUrl\n              presentation {\n                coverUrl\n                portalId\n                name\n                menuId\n                folderId\n              }\n              files {\n                _id\n                name\n                relatedPresentationIds\n                fileUrl\n                fileType\n                coverUrl\n                thumbnailUrl\n                positions {\n                  presentationId\n                  position\n                }\n                visibility\n                creator\n              }\n            }\n          }\n        }\n      }\n    }\n    ... on Response {\n      __typename\n      message\n      status\n      success\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '523f6814edac3ce9a00447f9344c455a';

module.exports = node;
